import React, { useState } from 'react';
import { Select, Form, Button, DatePicker } from 'antd';
import axios from '../../../utils/AxiosUtil';
import { modalHint } from '../../../components/reqAndHint'

import 'dayjs/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { useSelector } from 'react-redux'

// 新建项目
export default function ProjectForm(props) {
    const langValue = useSelector(state => state.langList.value)
    const [form] = Form.useForm();
    const { Option } = Select;

    function resetFormFields() {
        // console.log('form reset fields*');
        form.resetFields();
    }

    //验证未通过
    function onFinishFailed({ values, errorFields, outOfDate }) {
        // console.log("addArea form onFinishFailed:", values, errorFields, outOfDate);
    }

    //点击“新建”按钮（提交表单）
    function onFinish(values) {
        // console.log("addArea form onFinish:", values);
        // 成功提示 后台改动，成功在data，失败在error
        axios.post('/fund/project/add', values).then((data) => {
            modalHint('success', data.data.msg, () => {
                resetFormFields();
                props.handleSuccess(values);
            });
        })
            .catch((e) => {
                modalHint('error', e.response.data.msg);
            });
    }


    return (
        <Form
            name="add-project"
            form={form}
            onFinishFailed={onFinishFailed}
            onFinish={onFinish}
            initialValues={{
                permission: '通用',
                projectStatus: 'on',
                // 设置初始值 减少组件报错
                donationItem: ''
            }}
        >
            <div>{langValue==0?'捐款项目Donation project':(langValue==1?'捐款项目':'Donation project')}：</div>
            <Form.Item
                name="donationItem"
                rules={[{ required: true, message: '请输入项目名称' }]}
            >
                <input placeholder={langValue==0?'请输入Please enter':(langValue==1?'请输入':'Please enter')}
                    style={{ width: 230, paddingLeft: 10 }} />
            </Form.Item>

            <div>{langValue==0?'权限设置Permission settings':(langValue==1?'权限设置':'Permission settings')}：</div>
            <Form.Item
                name="permission"
            >
                <Select style={{ width: 230 }} >
                    <Option value="通用" key="on">{langValue==0?'通用General':(langValue==1?'通用':'General')}</Option>
                    <Option value="不通用" key="off">{langValue==0?'不通用Not general':(langValue==1?'不通用':'Not general')}</Option>
                </Select>
            </Form.Item>

            <div>{langValue==0?'停用日期Date Deactivated':(langValue==1?'停用日期':'Date Deactivated')}：</div>
            <Form.Item
                name="deadline"
                rules={[{ required: true, message: '请选择日期' }]}
            >
                <DatePicker
                    locale={locale}
                    placeholder={langValue==0?'请输入Please enter':(langValue==1?'请输入':'Please enter')}
                    style={{ width: 230 }}
                />
            </Form.Item>

            <div>{langValue==0?'状态Status':(langValue==1?'状态':'Status')}：</div>
            <Form.Item
                name="projectStatus"
            >
                <Select style={{ width: 230 }} >
                    <Option value="on" key="on">{langValue==0?'启用Active':(langValue==1?'启用':'Active')}</Option>
                    <Option value="off" key="off">{langValue==0?'停用Inactive':(langValue==1?'停用':'Inactive')}</Option>
                </Select>
            </Form.Item>

            <div>
                <Button type="primary" htmlType="submit" >
                    {langValue==0?'新建Create':(langValue==1?'新建':'Create')}
                </Button>
            </div>

        </Form>
    )
}
